import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link, useLocation } from "react-router-dom";
import $ from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';


const ExhibitorTopMenu = ({ head, userId }) => {
    const history = useNavigate();
    const navigate = useNavigate();
    const location = useLocation();
    const activeTabRef = useRef(null);

    const [isOpen, setIsOpen] = useState(false)
    const [loginAccesslist, setLoginAccesslist] = useState([])
    const [isAccountsOpen, setIsAccountsOpen] = useState(false)
    const [accountsPos, setAccountsPos] = useState({ top: 0, left: 0 })
    const accountsRef = useRef(null)

    const [isPassesOpen, setIsPassesOpen] = useState(false)
    const [passesPos, setPassesPos] = useState({ top: 0, left: 0 })
    const passesRef = useRef(null)

    const toggleAccounts = () => {
        if (!isAccountsOpen && accountsRef.current) {
            const rect = accountsRef.current.getBoundingClientRect();
            setAccountsPos({ top: rect.bottom, left: rect.left });
        }
        setIsAccountsOpen(prev => !prev);
    }

    const togglePasses = () => {
        if (!isPassesOpen && passesRef.current) {
            const rect = passesRef.current.getBoundingClientRect();
            setPassesPos({ top: rect.bottom, left: rect.left });
        }
        setIsPassesOpen(prev => !prev);
    }

    //toggle model for logout.................................
    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //     'js/jquery.sticky.js',
        //     'js/metisMenu.min.js',
        //     'js/metisMenu-active.js',
        //     'js/main.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //     const node = document.createElement('script');
        //     node.src = dynamicScripts[i];
        //     node.type = 'text/javascript';
        //     node.async = false;
        //     document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }
    const logout = () => {
        sessionStorage.clear()
        navigate('/')
    }
    useEffect(() => {
        console.log("ExhibitorTopMenu")
        console.log('is paid registration : ', sessionStorage.getItem('isPaidByAgentRegistration'));
        console.log('isIndirectAccess : ', sessionStorage.getItem('isIndirectAccess'));
        if (activeTabRef.current) {
            activeTabRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [location.pathname]);

    const onRedirect = (path) => {
        history.push({ pathname: path, state: { 'isSearchClear': true } });
    }

    const isRouteActive = (routePath) => {
        return location.pathname == routePath
    }

    const accountsRoutes = ['/updatePayment', '/receiptlist', '/proformalist', '/taxInvoices'];
    const isAccountsActive = () => accountsRoutes.includes(location.pathname);

    const passesRoutes = ['/entryPass', '/exitPass'];
    const isPassesActive = () => passesRoutes.includes(location.pathname);

    // close the dropdowns when clicking outside or changing route
    useEffect(() => {
        setIsAccountsOpen(false);
        setIsPassesOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (accountsRef.current && !accountsRef.current.contains(e.target)) {
                setIsAccountsOpen(false);
            }
            if (passesRef.current && !passesRef.current.contains(e.target)) {
                setIsPassesOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const isManualFormsActive = () => {
        const formRoutes = ['/manualForms', '/manualFormsVendorList', '/fascia-form', '/exhibitorbadge', '/exhibitorDetails',
            '/visaApplication', '/edirectoryList', '/keywordsInformation', '/stallDesign', '/aditionalfurniture',
            '/stallpossesion', '/powerConnection', '/freightForward', '/water', '/airConnectionApplication',
            '/carPassesApplication', '/liquareLicense', '/leadRetrievalConnectionApplication', '/meetingRoomRequestForm',
            '/delegateMeeting', '/visitorMeetingApplication', '/internetConnection', '/housekeepingConnection',
            '/securityApplication', '/cateringServices', '/hostHostessRequirements', '/brandingApportunityAndAdvertisement',
            '/rentalAudioAndVedioEquipment', '/exhibitorContractorBadgeApplication', '/plantAndBeautification'];
        return formRoutes.includes(location.pathname);
    }

    const isRoleId8 = sessionStorage.getItem("RoleIDSS") != null && sessionStorage.getItem("RoleIDSS") == 8;

    return (
        <>
            <Modal isOpen={isOpen} onRequestClose={e => toggleModal()}>
                <div className="modal-dialog modal-dialog-centered bd-example-modal-lg" >
                    <div className="modal-content" style={{ borderRadius: '0px' }}>
                        <div className="modal-header p-2">
                            <h4 className="modal-title text-white">Confirm Logout</h4>
                            {/* <button type="button" class="close modal-close" data-dismiss="modal" onClick={this.toggleModal}>&times;</button> */}
                            {/* <button type="button " className="close pop-close text-dark" data-dismiss="modal" onClick={e => toggleModal()} >
                                <span aria-hidden="true" class="pop-cancel">&times;</span></button> */}

                        </div>
                        <div class="modal-body pl-0 pt-4 pb-4">
                            <p class="pop_label">Do you really want to logout?</p>
                        </div>
                        <div className='modal-footer d-block p-2'>
                            <button className="btn btn-aqua" onClick={logout}> Yes</button>
                            <button class="btn btn-gray" data-dismiss="modal" onClick={toggleModal}> No</button>
                        </div>

                    </div>
                </div>
            </Modal>
            {/* Top menu */}
            <div className="navg">
                <ul className="nav nav-pills with-dr-container tab-scroll-fixed" style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                    <Link to={'/exhibitor_dashboard'}>
                        <li className="nav-item " ref={isRouteActive('/exhibitor_dashboard') ? activeTabRef : null}>
                            {" "}
                            <a className={isRouteActive('/exhibitor_dashboard') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                Dashboard{" "}
                            </a>{" "}
                        </li>
                    </Link>
                    {
                        (sessionStorage.getItem('isIndirectAccess') && sessionStorage.getItem('isIndirectAccess') != null &&
                            sessionStorage.getItem('isIndirectAccess') == 'true') || (sessionStorage.getItem('isPaidByAgentRegistration') != null && sessionStorage.getItem('isPaidByAgentRegistration') == 1) || (sessionStorage.getItem("RoleIDSS") != null && sessionStorage.getItem("RoleIDSS") == 8) ?
                            <Link to={'/manualForms'}>
                                <li className="nav-item ">
                                    {" "}
                                    <a className={isRouteActive('/manualForms') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        Manual Forms
                                    </a>{" "}
                                </li>
                            </Link>
                            :
                            (JSON.parse(sessionStorage.getItem('sessionHeaderData')) &&
                                JSON.parse(sessionStorage.getItem('sessionHeaderData')) != null &&
                                JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['Flag'] != null &&
                                (JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['Flag']))

                            // ((JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['Flag'])  || 
                            // (JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['Flag']) == false))
                            &&
                            <Link to={'/manualForms'}>
                                <li className="nav-item ">
                                    {" "}
                                    <a className={isRouteActive('/manualForms') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        Manual Forms
                                    </a>{" "}
                                </li>
                            </Link>
                    }
                    {((sessionStorage.getItem('isPaidByAgentRegistration') != null && sessionStorage.getItem('isPaidByAgentRegistration') == 0) ||
                        (sessionStorage.getItem('isIndirectAccess') != null && sessionStorage.getItem('isIndirectAccess') == 'true') || isRoleId8) && (
                            <Link to={'/rulesRegulations'}>
                                <li className="nav-item " ref={isRouteActive('/rulesRegulations') ? activeTabRef : null}>
                                    {" "}
                                    <a className={isRouteActive('/rulesRegulations') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        Rules and Regulations
                                    </a>{" "}
                                </li>
                            </Link>
                        )}
                    <Link to={'/importantDates'}>
                        <li className="nav-item " ref={isRouteActive('/importantDates') ? activeTabRef : null}>
                            {" "}
                            <a className={isRouteActive('/importantDates') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"} >
                                Important Dates
                            </a>{" "}
                        </li>
                    </Link>
                    {isRoleId8 ? <Link to={'/partnerApplication'}>
                        <li className="nav-item " ref={isRouteActive('/partnerApplication') ? activeTabRef : null}>
                            {" "}
                            <a className={isRouteActive('/partnerApplication') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                Partner Application
                            </a>{" "}
                        </li>
                    </Link> :
                        <Link to={'/spacebooking'}>
                            <li className="nav-item " ref={isRouteActive('/spacebooking') ? activeTabRef : null}>
                                {" "}
                                <a className={isRouteActive('/spacebooking') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                    Spacebooking Form
                                </a>{" "}
                            </li>
                        </Link>}
                    {!isRoleId8 &&
                        <li
                            className="nav-item"
                            ref={(el) => { passesRef.current = el; if (isPassesActive()) activeTabRef.current = el; }}
                            style={{ position: 'relative' }}
                        >
                            <a
                                className={isPassesActive() ? "nav-link active px-4 py-2" : "nav-link px-4 py-2"}
                                style={{ cursor: 'pointer' }}
                                onClick={togglePasses}
                            >
                                Entry/Exit Pass <i className={`fa fa-chevron-${isPassesOpen ? 'up' : 'down'}`} style={{ fontSize: '10px', marginLeft: '4px' }} />
                            </a>
                            {isPassesOpen &&
                                <ul
                                    className="shadow"
                                    style={{
                                        position: 'fixed',
                                        top: passesPos.top,
                                        left: passesPos.left,
                                        zIndex: 2000,
                                        minWidth: '200px',
                                        background: '#fff',
                                        listStyle: 'none',
                                        padding: '4px 0',
                                        margin: 0,
                                        borderRadius: '4px',
                                        border: '1px solid #e0e0e0',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    <Link to={'/entryPass'} onClick={() => setIsPassesOpen(false)}>
                                        <li className="dropdown-item px-3 py-2" style={{ cursor: 'pointer', fontWeight: isRouteActive('/entryPass') ? 'bold' : 'normal' }}>
                                            Entry Pass
                                        </li>
                                    </Link>
                                    <Link to={'/exitPass'} onClick={() => setIsPassesOpen(false)}>
                                        <li className="dropdown-item px-3 py-2" style={{ cursor: 'pointer', fontWeight: isRouteActive('/exitPass') ? 'bold' : 'normal' }}>
                                            Exit Pass
                                        </li>
                                    </Link>
                                </ul>
                            }
                        </li>
                    }
                    {/* <Link to={'/exhibitorSeminar'}>
                        <li className="nav-item ">
                            {" "}
                            <a className={isRouteActive('/exhibitorSeminar') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                Exhibitor Seminar{" "}
                            </a>{" "}
                        </li>
                    </Link> */}

                    {!isRoleId8 &&
                        <li
                            className="nav-item"
                            ref={(el) => { accountsRef.current = el; if (isAccountsActive()) activeTabRef.current = el; }}
                            style={{ position: 'relative' }}
                        >
                            <a
                                className={isAccountsActive() ? "nav-link active px-4 py-2" : "nav-link px-4 py-2"}
                                style={{ cursor: 'pointer' }}
                                onClick={toggleAccounts}
                            >
                                Accounts <i className={`fa fa-chevron-${isAccountsOpen ? 'up' : 'down'}`} style={{ fontSize: '10px', marginLeft: '4px' }} />
                            </a>
                            {isAccountsOpen &&
                                <ul
                                    className="shadow"
                                    style={{
                                        position: 'fixed',
                                        top: accountsPos.top,
                                        left: accountsPos.left,
                                        zIndex: 2000,
                                        minWidth: '200px',
                                        background: '#fff',
                                        listStyle: 'none',
                                        padding: '4px 0',
                                        margin: 0,
                                        borderRadius: '4px',
                                        border: '1px solid #e0e0e0',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    <Link to={'/updatePayment'} onClick={() => setIsAccountsOpen(false)}>
                                        <li className="dropdown-item px-3 py-2" style={{ cursor: 'pointer', fontWeight: isRouteActive('/updatePayment') ? 'bold' : 'normal' }}>
                                            Update Payment
                                        </li>
                                    </Link>
                                    <Link to={'/receiptlist'} onClick={() => setIsAccountsOpen(false)}>
                                        <li className="dropdown-item px-3 py-2" style={{ cursor: 'pointer', fontWeight: isRouteActive('/receiptlist') ? 'bold' : 'normal' }}>
                                            Receipt List
                                        </li>
                                    </Link>
                                    <Link to={'/proformalist'} onClick={() => setIsAccountsOpen(false)}>
                                        <li className="dropdown-item px-3 py-2" style={{ cursor: 'pointer', fontWeight: isRouteActive('/proformalist') ? 'bold' : 'normal' }}>
                                            Proforma Invoices
                                        </li>
                                    </Link>
                                    <Link to={'/taxInvoices'} onClick={() => setIsAccountsOpen(false)}>
                                        <li className="dropdown-item px-3 py-2" style={{ cursor: 'pointer', fontWeight: isRouteActive('/taxInvoices') ? 'bold' : 'normal' }}>
                                            Tax Invoices
                                        </li>
                                    </Link>
                                </ul>
                            }
                        </li>
                    }
                    {false && <Link to={'/ledgerList'}>
                        <li className="nav-item " ref={isRouteActive('/ledgerList') ? activeTabRef : null}>
                            {" "}
                            <a className={isRouteActive('/ledgerList') ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                Ledger
                            </a>{" "}
                        </li>
                    </Link>}


                </ul>

                {/* <span style={{ position: "absolute", right: "0", top: "7px" }}> */}
                {/* <span>
                        <Link to={'/Change_Password'}>
                            <i class="fa fa-cog"></i> Change Password
                        </Link>
                    </span> */}
                {/* <span className="log-11" onClick={e => toggleModal()}>
                        <i className="fa fa-power-off" aria-hidden="true" /> Logout
                    </span>
                </span> */}

            </div>

            {/* Top menu */}

        </>
    );
}
export default ExhibitorTopMenu;